module.exports = __webpack_public_path__ + "img/party-history.8119e617.webp";